import { useCallback } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { SlideOut, SlideOutHeader } from '@aimsos/ui';

import ItemUnavailableState from './ItemUnavailableState.jsx';

/** The slide-out for a link whose kind has no component registered (or is reserved). */
function ItemUnavailableSlideOut({ onClose }) {
  const { t } = useTranslation('unified-profiles');
  const title = t('itemSlideOut.unavailable.title');

  const renderHeader = useCallback(
    (titleId) => <SlideOutHeader titleId={titleId} title={title} showClose onClose={onClose} />,
    [title, onClose],
  );

  return (
    <SlideOut isOpen onClose={onClose} renderHeader={renderHeader} size="M" ariaLabel={title}>
      <ItemUnavailableState />
    </SlideOut>
  );
}

export default ItemUnavailableSlideOut;
